<!-- 조직관리 메인컴포넌트 -->
<template>
  <div class="tit-group">
    <h2 class="tit">{{t('message.organizationManagement')}}</h2>
  </div>
  <div class="tab-group">
    <v-tabs v-model="tab">
      <v-tab value="tabCont1" @click.stop="onClickTab(1)" v-if="Number(adminInfo?.authCompany) > 0 || userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2'">{{t('message.companyManagement')}}</v-tab>
      <v-tab value="tabCont2" @click.stop="onClickTab(2)" v-if="Number(adminInfo?.authMember) > 0 || userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2'">{{t('message.memberManagement')}}</v-tab>
      <v-tab value="tabCont3" @click.stop="onClickTab(3)" v-if="Number(adminInfo?.authAdmin) > 0 || userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2'">{{t('message.adminManagement')}}</v-tab>
      <v-tab value="tabCont4" @click.stop="onClickTab(4)" v-if="Number(adminInfo?.authBoard) > 0 || userInfo.roles == 'ADMIN1' || userInfo.roles == 'ADMIN2'">{{t('message.systemNotification')}}</v-tab>
    </v-tabs>
  </div>
  <div class="content-box bg-none">
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="tabCont1">
        <c-pageTabCont1/>
      </v-tabs-window-item>
      <v-tabs-window-item value="tabCont2">
        <c-pageTabCont2 v-if="pageType=='list'"/>
        <c-pageTabCont21 v-if="pageType=='view'"/>
      </v-tabs-window-item>
      <v-tabs-window-item value="tabCont3">
        <c-pageTabCont3 v-if="pageType=='list'"/>
        <c-pageTabCont31 v-if="pageType=='view'"/>
      </v-tabs-window-item>
      <v-tabs-window-item value="tabCont4">
        <c-pageTabCont4 v-if="pageType=='list'"/>
        <c-pageTabCont41 v-if="pageType=='view'"/>
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<style lang="scss">
</style>
<script lang="ts" setup>
import { useRoute } from 'vue-router'
import { useCommonStore } from "@/store/common";
import { storeToRefs } from 'pinia'
import { ref } from "vue";
import utils from "@/common/Utils";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()
const adminInfo:any = ref({})
const userInfo:any= ref({})

//bind
const tab = ref()
const tabIdx = ref(route.params.tab?route.params.tab:'')
const pageType = ref(route.params.page?route.params.page:'')

//hook
onMounted(() => {
  userInfo.value = JSON.parse(localStorage.getItem('user'))
  adminInfo.value = JSON.parse(localStorage.getItem("admin"))
  tab.value = 'tabCont'+tabIdx.value
})

const onClickTab=(type)=>{
  utils.movePage('/organizationalManagement/'+type+'/list')
}
</script>
